import React from 'react'
import FulfillmentStatus from '../../../list/components/FulfillmentStatus'
import PaymentStatus from '../../../list/components/PaymentStatus'
import {KTSVG} from '_metronic/helpers'
import {useNavigate, useLocation} from 'react-router-dom'

type Props = {
  title: string | any
  subTitle?: string | any
  fulfillmentStatus?: string | any
  paymentStatus?: string | any
  children?: React.ReactNode
  routePath: string
  locationState?: any
}

export const OrderHeader: React.FC<Props> = ({
  title,
  routePath,
  fulfillmentStatus,
  paymentStatus,
  children,
  subTitle,
  locationState,
}) => {
  const history = useNavigate()
  const {state}: any = useLocation()
  const handleNavigate = () => {
    if (state && state.wineClubId) {
      history(-1)
    } else if (routePath && locationState) {
      history(routePath, {state: locationState})
    } else if (routePath) {
      history(routePath, state || {})
    }
  }
  return (
    <div className='d-flex justify-content-between align-items-center'>
      <div className='d-flex align-items-center'>
        <h3 className='card-title align-items-start flex-column mb-5'>
          <div className='d-flex justify-content-between align-items-center'>
            <div className='mb-1 d-flex align-items-center me-1'>
              <KTSVG
                path={'/media/icons/corksy/arrow-left.svg'}
                className='svg-icon-3qx svg-icon-dark me-3 cursor-pointer pt-1'
                onClick={handleNavigate}
              />
            </div>
            <div>
              <div className='d-flex align-items-center mb-1'>
                {title}{' '}
                {fulfillmentStatus && (
                  <div className='ms-4'>
                    <FulfillmentStatus status={fulfillmentStatus} />
                  </div>
                )}
                {paymentStatus && (
                  <div className='ms-4'>
                    <PaymentStatus status={paymentStatus} />
                  </div>
                )}
              </div>
              <div className='fs-7 fw-light text-muted'>{subTitle}</div>
            </div>
          </div>
        </h3>
      </div>
      {children && <div className='mb-5'>{children}</div>}
    </div>
  )
}

export default OrderHeader
